<script>
import moment from "moment";
import { getOperateLogApi } from "../../api";

export default {
  name: "EditLogModal",

  props: {
    type: {
      type: String,
      default: "line",
    },
  },

  data() {
    return {
      dialogVisible: false,
      dataSource: [],
      previewDataSource: [],
    };
  },

  methods: {
    async openModal(val) {
      this.dialogVisible = true;
      const params = this.getRequestEditLogParams(val);
      const res = await this.requestEditLogData(params);
      this.dataSource = res.map((item) => ({
        ...item,
        operationTime: moment(item.operationTime).format("yyyy-MM-DD HH:mm:ss"),
        content: JSON.parse(item.content),
      }));
      this.previewDataSource = this.dataSource.slice(0, 2);
    },

    getRequestEditLogParams(val) {
      return {
        id: this.type === "line" ? val.id : val.stationId,
        logType: this.type === "line" ? "ROUTE_PRICE" : "STATION_INFO",
      };
    },

    // eslint-disable-next-line consistent-return
    async requestEditLogData(params) {
      try {
        const res = await getOperateLogApi(params);
        return res;
      } catch (err) {
        console.log(err);
      }
    },

    // 查看所有数据
    handlePreviewAllLog() {
      this.previewDataSource = this.dataSource.slice(0);
    },

    handleClose() {
      this.dataSource = [];
      this.previewDataSource = [];
      this.dialogVisible = false;
    },
  },
};
</script>

<template>
  <el-dialog title="修改日志" :visible.sync="dialogVisible" width="820px" :before-close="handleClose">
    <div v-if="dataSource.length" class="edit-log">
      <a-timeline>
        <a-timeline-item v-for="(item, index) in previewDataSource" :key="index" :timestamp="item.dateTime" placement="top">
          <p class="log-date">{{ item.operationTime }}</p>
          <div class="log-item">
            <span class="log-item__label">操作人：</span>
            <span class="log-item__value">{{ item.operatorName }}（{{ item.operatorPhone }}）</span>
          </div>
          <div class="log-item">
            <span class="log-item__label">操作类型：</span>
            <span class="log-item__value primary-text">{{ item.operationType === "UPDATE" ? "修改" : "新增" }}</span>
          </div>
          <div class="log-item">
            <span class="log-item__label">变更内容：</span>
            <div class="log-item__content">
              <div v-if="item.operationType === 'UPDATE'" class="log-item__content--box content__front">
                <div v-for="(ele, j) in item.content" :key="j" class="content-item">
                  <div class="content-item__label">{{ ele.fieldNameZh }}</div>
                  <div class="content-item__value">{{ ele.oldValue }}</div>
                </div>
              </div>
              <div v-if="item.operationType === 'UPDATE'" class="log-item__content--arraw">
                <a-icon type="double-right" />
              </div>
              <div class="log-item__content--box content__behind">
                <div v-for="(ele, j) in item.content" :key="j" class="content-item">
                  <div class="content-item__label">{{ ele.fieldNameZh }}</div>
                  <div class="content-item__value">{{ ele.value }}</div>
                </div>
              </div>
            </div>
          </div>
        </a-timeline-item>
      </a-timeline>
      <div v-if="dataSource.length !== previewDataSource.length" class="preview-all">
        <span @click="handlePreviewAllLog">
          <a-icon type="down" />
          查看全部{{ dataSource.length }}项
        </span>
      </div>
    </div>
    <a-empty v-else />
  </el-dialog>
</template>

<style lang="less" scoped>
.edit-log {
  .preview-all {
    width: 100%;
    text-align: center;
    color: #06b880;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      opacity: 0.8;
    }

    i {
      margin-right: 4px;
      font-size: 12px;
    }
  }

  .log-item {
    display: flex;
    background-color: #fafafb;
    padding: 6px 12px;

    &__label {
      width: 80px;
      color: #7e8694;
    }

    &__value {
      color: #1c2026;
    }

    &__content {
      display: flex;
      // align-items: center;

      &--box {
        width: 300px;
        padding: 8px;
        box-sizing: border-box;
        background-color: #fff;

        .content-item {
          margin: 6px 0;
          font-size: 12px;

          &__label {
            color: rgba(0, 0, 0, 0.45);
          }

          &__value {
            color: rgba(0, 0, 0, 0.85);
          }
        }
      }

      &--arraw {
        height: 100%;
        margin: 0 20px;
        display: flex;
        align-items: center;
      }
    }

    .primary-text {
      color: #404B5C;
    }
  }
}
</style>
